// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1PucF","notes":"Notes_notes__3PXq_","note":"Notes_note__VEJt9","markdown":"Notes_markdown__6afcf"};